<cap-content-header>
  <cap-title>
    {{ "Grundbuchperson" | translate }}:
    @if (personGbVersion) {
      <span>
        <cap-kompakt-persongb
          [auskunftsperre]="getAuskunftsperre(auskunftsperre)"
          [capHistinfo]="personGbVersion.histInfo"
          [item]="personGbVersion"
          [itemMasterId]="personGbMasterId">
        </cap-kompakt-persongb>
      </span>
    }
  </cap-title>
  @if (showTitlebutton) {
    <cap-title-functionbar>
      <div class="inline-form float-end">
        <cap-link
          [queryParams]="{ id: personGbMasterId.id, versionId: personGbVersion.id.id }"
          [target]="navTargets.NAV_PERSON_GB_VERGLEICH">
          {{ "VergleichMitZpvPerson" | translate }}
        </cap-link>
      </div>
    </cap-title-functionbar>
  }
</cap-content-header>
